import api from '@utils/api';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { OrdersActionTypes } from './common.types';
import OrdersSlice from './orders.slice';
function* handleFetchOrders() {
    yield put(OrdersSlice.actions.updateLoading(true));
    const orders = yield call(api.getOrders);
    yield put(OrdersSlice.actions.updateOrders(orders));
    yield put(OrdersSlice.actions.updateLoading(false));
}
function* handleFetchOrdersPaged() {
    yield put(OrdersSlice.actions.updateLoading(true));
    const orders = yield call(api.getOrdersNext, 1, 2);
    yield put(OrdersSlice.actions.updateOrdersNext(orders));
    yield put(OrdersSlice.actions.updateLoading(false));
}
function* handleFetchOrderDetail(action) {
    const { id, addToList } = action.payload;
    const orderToken = yield select((state) => state.orders.orderToken);
    const orderDetail = yield call(api.getOrderDetail, id, orderToken);
    if (addToList) {
        yield put(OrdersSlice.actions.updateOrderDetail({ id, orderDetail }));
    }
    else {
        yield put(OrdersSlice.actions.saveCurrentOrderDetail({ id, orderDetail }));
    }
}
function* handleFetchReturns() {
    yield put(OrdersSlice.actions.updateLoading(true));
    const returns = yield call(api.getReturns);
    yield put(OrdersSlice.actions.updateReturns(returns));
    yield put(OrdersSlice.actions.updateLoading(false));
}
function* handleFetchReturnsPaged() {
    yield put(OrdersSlice.actions.updateLoading(true));
    const returns = yield call(api.getReturnsNext, 1, 2);
    yield put(OrdersSlice.actions.updateReturnsNext(returns));
    yield put(OrdersSlice.actions.updateLoading(false));
}
function* handleUpdateReturn(action) {
    const orderDetail = action.payload;
    yield put(OrdersSlice.actions.updateOrderRequest(orderDetail));
}
function* handleSetError(action) {
    yield put(OrdersSlice.actions.setErrorMessage(action.payload));
}
function* handleCleanFormError() {
    yield put(OrdersSlice.actions.clearErrors());
}
function* watchFetchRequest() {
    yield takeEvery(OrdersActionTypes.FETCH_ORDERS, handleFetchOrders);
    yield takeEvery(OrdersActionTypes.FETCH_ORDERS_PAGED, handleFetchOrdersPaged);
    yield takeEvery(OrdersActionTypes.FETCH_ORDERS_DETAIL, handleFetchOrderDetail);
    yield takeEvery(OrdersActionTypes.FETCH_RETURNS, handleFetchReturns);
    yield takeEvery(OrdersActionTypes.FETCH_RETURNS_PAGED, handleFetchReturnsPaged);
    yield takeEvery(OrdersActionTypes.CLEAN_FORM_ERRORS, handleCleanFormError);
    yield takeEvery(OrdersActionTypes.UPDATE_RETURN, handleUpdateReturn);
    yield takeEvery(OrdersActionTypes.SET_ERROR, handleSetError);
}
export default function* ordersSaga() {
    yield all([fork(watchFetchRequest)]);
}
